import { FilterInfo } from "./filter-info";

export class WikiFilterInfo extends FilterInfo {
  constructor(options = {}) {
    // Set default options for wiki filter
    const wikiOptions = {
      queryId: "wiki-listing",
      perPage: 16,
      showingSelector: ".wiki__showing",
      totalSelector: ".wiki__total",
      hasSearchSummary: false,
      modifyInputValue: false,
    };

    // Merge with any user-provided options
    super({ ...wikiOptions, ...options });
  }
}
